import { Deployment } from '@/types/deployment';
import { EnabledDestinationMarketplacesResponse } from '@/types/house.types';
import { makeFetchOrThrow } from '@/data/helpers/makeFetch';
import { Method } from '@/data/enums/method';
import { QueryKey } from '@/data/enums/queryKeys';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { Services } from '@/data/enums/services';
import { useAppContext } from '@/providers/AppContextProvider/AppContextProvider';
import { useEffectiveHouseId } from '@/hooks/useEffectiveHouseId/useEffectiveHouseId';

type GetEnabledDestinationMarketplacesOptions = Readonly<{
    deployment: Deployment;
    enabled?: boolean;
    houseId: string;
    token: string;
}>;

export const getEnabledDestinationMarketplacesOptions = ({
    deployment,
    enabled = true,
    houseId,
    token,
}: GetEnabledDestinationMarketplacesOptions) =>
    queryOptions({
        enabled: Boolean(enabled && houseId && token),
        queryFn: () =>
            makeFetchOrThrow<EnabledDestinationMarketplacesResponse>({
                apiPath: `houses/${houseId}/enabled-destination-marketplaces`,
                apiService: Services.SellerPortal,
                deployment,
                method: Method.Get,
                token,
            }),
        queryKey: [QueryKey.EnabledDestinationMarketplaces, houseId],
    });

export const useGetEnabledDestinationMarketplaces = ({ enabled = true }: Readonly<{ enabled?: boolean }> = {}) => {
    const { deployment, token } = useAppContext();
    const houseId = useEffectiveHouseId();

    return useQuery(getEnabledDestinationMarketplacesOptions({ deployment, enabled, houseId, token }));
};
